import { render, staticRenderFns } from "./ThanksEnd.vue?vue&type=template&id=a2aef814&scoped=true&"
import script from "./ThanksEnd.vue?vue&type=script&lang=js&"
export * from "./ThanksEnd.vue?vue&type=script&lang=js&"
import style0 from "./ThanksEnd.vue?vue&type=style&index=0&id=a2aef814&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2aef814",
  null
  
)

export default component.exports